define('home/mixins/withChannelBanner',[
    'underscore',

    'home/models/Channel',
], function (
    _,

    Channel
) {
    'use strict';

    var BANNER_COLOR_CLASSES = _.chain(Channel.BANNER_COLORS)
        .keys()
        .map(function (color) {
            return '-' + color;
        })
        .value()
        .join(' ');


    /**
     * Used on a view that contains a channel banner. Will properly render/update
     * the banner to show the appropriate color or image as indicated/updated in
     * the backing channel model.
     *
     * Expects this.model to be a Channel.
     * Banner element should have data-role=banner.
     */
    var withChannelBanner = {
        ui: {
            // this data-role must also include .banner__wrapper for
            // banner colors to display visually
            bannerWrapper: '[data-role=banner]',
        },

        initialize: function (_initialize, options) {
            _initialize.call(this, options);

            this.listenTo(this.model, 'change:bannerColor change:banner change:options', this.updateBanner);
        },

        onRender: function (_onRender) {
            if (_onRender)
                _onRender.apply(this, _.rest(arguments));

            this.updateBanner();
        },

        updateBanner: function () {
            this.ui.bannerWrapper
                .removeClass(BANNER_COLOR_CLASSES)
                .removeClass('-image-background')
                .css({
                    'background-image': '',
                });

            var backgroundColor = this.model.get('bannerColor');
            var backgroundImage = this.model.get('banner') || this.model.get('options').alertBackground;

            // Until we're able to preview an image file before saving, show a placeholder which
            // indicates a custom image banner background.
            if (backgroundImage instanceof window.File)
                backgroundImage = '//media.disquscdn.com/home/channels/banner-image-upload.png';

            if (backgroundImage) {
                this.ui.bannerWrapper
                    .addClass('-image-background')
                    .css({
                        'background-image': 'url(' + backgroundImage + ')',
                        'background-position': '0 0;',
                    });
            }

            if (backgroundColor)
                this.ui.bannerWrapper.addClass('-' + backgroundColor.toLowerCase());
        },
    };

    return function () {
        this.ui = _.extend({}, withChannelBanner.ui, this.ui);
        this.initialize = _.wrap(this.initialize, withChannelBanner.initialize);
        this.onRender = _.wrap(this.onRender, withChannelBanner.onRender);

        _.defaults(this, _.pick(withChannelBanner, [
            'updateBanner',
        ]));
    };
});

